/** @module Classes */ /** typedoc */
import { keys } from 'ts-transformer-keys/index';
import { AssetPurchaseFormatEnum, IntensityEnum, AssetPurchaseUnavailableCodeEnum } from '../../enums';
import { InvoicePreview } from './InvoicePreview';
import { AbstractPreparePurchase } from './AbstractPreparePurchase';

export interface MasteringOptions {
    intensity?: IntensityEnum;
    versionId?: string;
}

export class AssetPreparePurchase extends AbstractPreparePurchase {
    public invoicePreview: InvoicePreview = null;
    public isAvailable = false;
    public isOffline: boolean = null;
    public productCode: AssetPurchaseFormatEnum = null;
    public productSegment: string = null;
    public reasonCode: AssetPurchaseUnavailableCodeEnum = null;
    // Corresponds to the remaining quantity NOT INCLUDING current invoicePreview
    public remainingFreeQuantity: number = null;
}

export const keysOfAssetPreparePurchase: Array<keyof AssetPreparePurchase> = keys<AssetPreparePurchase>();
